export const WIDTH_MOBILE = 650;
export const WIDTH_TABLET_768 = 768;
export const WIDTH_TABLET_1024 = 1024;

export const MAX_MOVIES_DESKTOP = 12;
export const MAX_MOVIES_TABLET = 8;
export const MAX_MOVIES_MOBILE = 5;

export const ADD_MOVIES = 2;
export const ADD_MOVIES_DESKTOP = 3;
